"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Input = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var Input = exports.Input = function Input(_ref) {
  var label = _ref.label,
    id = _ref.id,
    placeholder = _ref.placeholder,
    value = _ref.value,
    onChange = _ref.onChange,
    containerClassName = _ref.containerClassName;
  var optionalValue = value ? {
    value: value
  } : {};
  var optionalOnChange = onChange ? {
    onChange: onChange
  } : {};
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: containerClassName
  }, /*#__PURE__*/_react["default"].createElement("label", {
    className: "text-small text-slate-800",
    htmlFor: id
  }, label), /*#__PURE__*/_react["default"].createElement("input", _extends({}, optionalValue, optionalOnChange, {
    id: id,
    name: id,
    placeholder: placeholder,
    className: "border border-slate-300 w-full px-large py-regular rounded-lg outline-none focus:border-blue-600 mt-regular",
    required: true
  })));
};